import { render, staticRenderFns } from "./Komform.vue?vue&type=template&id=4fb52937&"
import script from "./Komform.vue?vue&type=script&lang=js&"
export * from "./Komform.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports